<template>
  <div class="drinks-window-component">
    <h1 class="font-weight-regular">
      Выбор напитка к заказу:
    </h1>

    <div class="button-group d-flex justify-between">
      <v-row class="justify-space-between">
        <v-col sm="5">
          <v-btn
            class="button button-back"
            width="100%"
            color="#F1F3F6"
            @click="goBack"
          >
            <font-awesome-icon icon="chevron-left" />
            Вернуться назад
          </v-btn>
        </v-col>
        <v-col sm="5">
          <v-btn
            class="button button-edit"
            width="100%"
            color="#F1F3F6"
            :loading="isLoading"
            @click="goToEdit"
          >
            <font-awesome-icon icon="edit" />
            Редактировать
          </v-btn>
        </v-col>
      </v-row>
    </div>

    <v-loader v-show="isLoadingCategories" absolute />
    <v-row v-if="items.length" class="menu-items">
      <v-loader v-show="isLoading" absolute />
      <v-col v-for="(item, i) in items" :key="i" sm="3">
        <food-card
          :item="item"
          new
          bonus
          child
        />
      </v-col>
    </v-row>
    <span v-else-if="!isLoading && !isLoadingCategories" class="d-block display-3 text-center">Напитки не найдены...</span>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import VLoader from '@/components/loader/Loader'
  import FoodCard from '../food-card/FoodCard'
  import editSessionApi from '@/api/order/edit-session'

  export default {
    name: 'DrinksWindow',
    components: {
      VLoader,
      FoodCard,
    },
    data () {
      return {
        items: [],
      }
    },
    computed: {
      ...mapState({
        orderId: state => state.fastOrder.orderId,
        isLoading: (state) => state.fastOrder.isMenuItemsLoading,
        categories: state => state.categories.categoriesList,
        isLoadingCategories: state => state.categories.isLoading,
      }),
    },
    mounted () {
      this.openDrinkCategory()
    },
    methods: {
      goToEdit () {
        editSessionApi.open(this.orderId)
        this.$router.push({
          path: '/edit-order',
          query: {
            id: this.orderId,
          },
        })
      },
      openDrinkCategory () {
        this.$store.commit('fastOrder/setFoodWindowState', false)
        const drinkCategory = this.categories.find(category => category.slug === 'drinks')
        if (drinkCategory) {
          this.getCategory(drinkCategory.id)
        } else {
          this.getCategory(10) // TODO Убрать хардкод категории напитков
        }
      },
      getCategory (id) {
        this.$store.dispatch('categories/fetchFilialMenuSingleCategories', { id })
          .then(res => {
            this.items = res.data.data.menuItems
          })
      },
      goBack () {
        this.$store.commit('fastOrder/setCurrentOtherWindow', undefined)
      },
    },
  }
</script>

<style lang="less" scoped>
  .drinks-window-component {
    background-color: transparent;

    h1 {
      font-size: 34px;
      line-height: 1;
      margin-bottom: 33px;
    }

    .menu-items {
      position: relative;
      z-index: 0;
    }

    .button {
      height: 80px;
      border-radius: 10px;

      svg {
        margin-right: 8px;
      }
    }

    .button-group {
      margin-bottom: 30px;

      .button {
        font-size: 15px;
        box-shadow: 0 3px 6px #00000029 !important;
      }

      .button-back {
        svg {
          .fill-svg(#0033ff);
        }
      }

      .button-edit {
        color: @color-primary;

        svg {
          .fill-svg(@color-primary);
        }
      }
    }
  }
</style>
